import { combineReducers } from 'redux';

import imagesAtlas from './Atlas/imagesAtlas.reducer';
import zoomAtlas from './Atlas/zoom.reducer';
import contextSideMenuAtlas from './Atlas/contextSideMenu.reducer';
import algorithmPanelAtlas from './Atlas/algorithmPanel.reducer';
import maxrectAtlas from './Atlas/maxrect.reducer';
import zoomAnim from './Animator/zoom.anim.reducer';
import atlasAnim from './Animator/atlas.anim.reducer';
import AnimationList from './Animator/animation.list.reducer';

const rootReducer = combineReducers({
    imagesAtlas,
    contextSideMenuAtlas,
    zoomAtlas,
    algorithmPanelAtlas,
    maxrectAtlas,
    // Sescción de reducers para animación
    zoomAnim,
    atlasAnim,
    AnimationList
});

export default rootReducer;